// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 772 ? "page-temp-voice" : chunkId) + "." + {"772":"1974e025","976":"287b59e5"}[chunkId] + ".chunk.css";
};